export function getContrast(hexcolor: string) {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0,2), 16);
  const g = parseInt(hexcolor.substr(2,2), 16);
  const b = parseInt(hexcolor.substr(4,2), 16);
  const y = ((r*299)+(g*587)+(b*114))/1000;
  return (y >= 128) ? 'black' : 'white';
}

export function luminance(hexcolor: string, luminosity: number) {
  hexcolor = String(hexcolor).replace(/[^0-9a-f]/gi, '');
  if (hexcolor.length < 6) {
    hexcolor = hexcolor[0]
      + hexcolor[0]
      + hexcolor[1]
      + hexcolor[1]
      + hexcolor[2]
      + hexcolor[2];
  }
  luminosity = luminosity || 0;
  let rgb = '#', c: any, i: number;
  for (i = 0; i < 3; i++) {
    c = parseInt(hexcolor.substr(i*2,2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * luminosity)), 255)).toString(16);
    rgb += ('00'+c).substr(c.length);
  }
  return rgb;
}
